import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.598.75h10.803s1.957 0 1.957 1.957v18.586s0 1.957-1.957 1.957H6.598s-1.957 0-1.957-1.957V2.707S4.641.75 6.598.75"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.02 4.052H8.98a1.06 1.06 0 0 1-1.049-.9L7.576.75h8.848l-.355 2.4a1.06 1.06 0 0 1-1.049.902"
    }, null, -1)
  ]));
}
const computerDeviceMobilePhoneIphoneX = { render };
export {
  computerDeviceMobilePhoneIphoneX as default,
  render
};
//# sourceMappingURL=computer-device-mobile-phone-iphone-x.svg.js.map
